var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import { t } from '@mp/locale';
import Button from '../../button';
import { StepContext } from "../../hooks/StepContext";
export default function StepButtons(_a) {
    var disableAll = _a.disableAll, valid = _a.valid, nextButtonLabel = _a.nextButtonLabel, hideBackButton = _a.hideBackButton;
    var back = useContext(StepContext).back;
    return (_jsxs("div", __assign({ className: "mp-capturesvc-button-container" }, { children: [!hideBackButton && (_jsx(Button, { dark: true, disabled: disableAll, htmlId: "mp-capture-service-back", label: t("CAPTURE_SERVICES.SCHEDULER.back"), buttonType: "secondary", onClick: back })), _jsx(Button, { dark: true, disabled: !valid() || disableAll, htmlId: "mp-capture-service-next", label: nextButtonLabel || t("CAPTURE_SERVICES.SCHEDULER.next"), buttonType: "primary", type: "submit" })] })));
}
